// assets/custom-grid-cards.js
// 纯外部JS，无全局污染，支持页面多个组件实例
document.addEventListener('DOMContentLoaded', () => {
  // 配置项
  const ANIMATION_DURATION = 2000;// 动画时长（毫秒）

  // 查询页面【所有】当前组件（依靠class，不依赖id/liquid）
  const cardSections = document.querySelectorAll('.custom-grid-cards');
  if (!cardSections.length) return;

  // 数字动画函数
  function animateNumber(element) {
    const target = parseInt(element.dataset.target);
    if (isNaN(target)) return;

    let startTime = null;
    let current = 0;

    function run(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / ANIMATION_DURATION, 1);
      
      current = Math.floor(progress * target);
      if (progress < 0.9) current += Math.floor(Math.random() * (target * 0.2));
      current = Math.min(current, target);

      element.textContent = current;
      progress < 1 ? requestAnimationFrame(run) : element.textContent = target;
    }
    requestAnimationFrame(run);
  }

  // 遍历每个组件实例，独立初始化
  cardSections.forEach(section => {
    // 仅查找当前组件内的数字（天然隔离，不影响其他组件）
    const numberElements = section.querySelectorAll('.card-animate-number');
    if (!numberElements.length) return;

    // 视口监听
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateNumber(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    numberElements.forEach(el => observer.observe(el));

    // Shopify 组件卸载清理
    document.addEventListener('shopify:section:unload', () => {
      numberElements.forEach(el => observer.unobserve(el));
    });
  });
});